import { IconButton, IconButtonProps, styled } from "@mui/material";
import React from "react";

export const PageHeaderIconButton = styled(IconButton)(({ theme }) => ({
  color: "inherit",
  type: "button",
  height: "59px",
  width: "59px",
})) as React.ComponentType<IconButtonProps>;
